import React, { useEffect } from 'react';
import { Button, Empty, message, Popconfirm, Space, Table, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { IDispenseCours } from 'app/shared/model/dispense-cours.model';
import { deleteDispenseCours, getDispensesCours } from './dispense-cours.reducer';
import { formatDispenseMatiereLabel } from './dispenses-cours.utils';

interface IDispensesTabProps {
  isActive: boolean;
}

const DispensesTab: React.FC<IDispensesTabProps> = ({ isActive }) => {
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  const dispenses = useAppSelector(state => state.dispenseCours.entities);
  const loading = useAppSelector(state => state.dispenseCours.loading);

  const inscriptionId = eleve?.inscriptionId;

  const loadDispenses = () => {
    if (!inscriptionId) return;
    dispatch(getDispensesCours({ inscriptionId }));
  };

  useEffect(() => {
    if (!isActive) return;
    loadDispenses();
  }, [isActive, inscriptionId]);

  const deleteDispense = async (id: string) => {
    await dispatch(deleteDispenseCours(id)).unwrap();
    message.success('Dispense supprimée');
    loadDispenses();
  };

  const columns = [
    {
      title: 'Matière',
      dataIndex: 'matiereNom',
      key: 'matiereNom',
      render: (_, record: IDispenseCours) => <Tag color="blue">{formatDispenseMatiereLabel(record)}</Tag>,
    },
    { title: 'Motif', dataIndex: 'motif', key: 'motif', render: value => value || '-' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record: IDispenseCours) => (
        <Popconfirm title="Supprimer cette dispense ?" onConfirm={() => deleteDispense(record.id)}>
          <Button type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  if (!inscriptionId) {
    return <Empty description="Aucune inscription active pour cette année scolaire" />;
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      <Table rowKey="id" loading={loading} columns={columns} dataSource={dispenses} pagination={false} />
    </Space>
  );
};

export default DispensesTab;
